import { createdUserSchema } from "../schemas/admin-user";
import { fetchApi } from "./internal";

export const users = {
	create: (data: unknown) =>
		fetchApi("/admin/users", createdUserSchema, {
			method: "POST",
			body: JSON.stringify(data),
		}),
};
